export class PanelKeys {
  panelToken?: string;
}

export class PanelKeysName {
  panelToken = 'panel_token';
}
